import React, { Component } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { applyDataTable, destroyDataTable } from '../../../custom/dataTable';
import View from '../../../../assets/img/svg/view.svg';
import Edit from '../../../../assets/img/svg/edit.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import FilterIcon from '../../../../assets/img/svg/FilterIcon.svg'
import del from "../../../../assets/img/svg/Del.svg"
import download from "../../../../assets/img/svg/DownloadIcon.svg"
import Autocomplete from "react-autocomplete"
import { useNavigate } from "react-router-dom";
import Pagination from "../../../custom/Pagination";
import $, { valHooks } from "jquery"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Tabs, Tab, AppBar, Box } from '@material-ui/core';
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { getIADOS_ListView, deletemulitiiadosdocs } from "../../../../actions/IADOSAction";
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import moment from "moment";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { getSettingsFormat } from "../../../../actions/SettingsAction";
const useStyles = makeStyles((theme) => ({
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    fontIcon: {
        paddingRight: "8px",
    }
}));
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

class ListViewIADOS extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ProjectId: 0,
            isMobile: false,
            IADOS_ListView: [],
            DownDelete: [],
            EditAudit: 0,
            value: 0,
            index:1,
            isAccess: false,
            Audit_ListView: [],
            searchData: {
                ProjectId: 0,
                FromDate: '',
                ToDate: '',
                PageNumber: 1,
                PageSize: 10,
                SortBy: 'date',
                SortOrder: 'asc'
            },
            hide: 0,
            linkValue: 0,
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        if (this.state.UserRole === "Admin" || this.state.UserRole == "Supervisor") {
            this.setState({ isAccess: true })
        }
        else {
            this.setState({ isAccess: false })
        }
        this.state.linkValue = parseInt(localStorage.getItem("InitialAuditValue"));
        if (this.state.linkValue) {
            this.setState({
                value: this.state.linkValue
            })
        }
        else {
            localStorage.setItem("InitialAuditValue", 0)
            this.setState({
                value: 0
            })
        }
        this.dataTable(this.state.searchData, this.state.ProjectId)
        this.AuditTable(this.state.ProjectId)
        this.props.dispatch(getSettingsFormat(this.state.searchData.ProjectId))
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        if (!window.location.pathname.includes('/initialauditdailyobservationstatus')) {
            localStorage.removeItem("InitialAuditValue")
        }
        $("#INIT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Initial1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Initial").addClass("d-none");
        $("#Initial").removeClass("d-block");
        $("#IADOSL").removeClass("active-color");
        $("#IADOST").removeClass("fw-bolder");
    }
    resize1 = () => {
        this.state.Audit_ListView = this.props.Audit_ListView;
        this.setState({})
        $("#INIT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Initial1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Initial").removeClass("d-none");
        $("#Initial").addClass("d-block");
        $("#IADOSL").addClass("active-color");
        $("#IADOST").addClass("fw-bolder");
    }
    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
        localStorage.setItem("InitialAuditValue", newValue)
        if (newValue == 0) {
            this.dataTable(this.state.searchData, this.state.ProjectId)
        }
        else {
            this.AuditTable(this.state.ProjectId)
        }
    };
    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId)
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId)
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        // if (!window.location.pathname.includes('initialauditdailyobservationstatus')) {
        //     localStorage.removeItem("InitialAuditValue")
        // }
        // $("#INIT1 .MuiListItemText-primary").addClass("spanTopBar");
        // $("#Initial1 .MuiListItemText-primary").addClass("fw-bolder");
        // $("#Initial").removeClass("d-none");
        // $("#Initial").addClass("d-block");
        // $("#IADOSL").addClass("active-color");
        // $("#IADOST").addClass("fw-bolder");
        this.state.IADOS_ListView = this.props.IADOS_ListView;
        this.state.Audit_ListView = this.props.Audit_ListView;
        this.setState({})
    };

    sidebar = () => {
        this.props.navigate("/sidebar");
    }
    AddNew = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/initialauditdailyobservationstatus/addnew")
    };
    EditPage = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/initialauditdailyobservationstatus/edit")
    };
    ViewPageLink = (id) => {
        localStorage.setItem("IADOSViewId", id)
        this.props.navigate("/initialauditdailyobservationstatus/view")
    }
    ViewPage = () => {
        if (this.state.DownDelete.length == 1) {
            this.props.navigate("/initialauditdailyobservationstatus/view")
        }
    };
    DeleteItem = () => {
        if (this.state.value == 0) {
            const { DownDelete } = this.state;
            window.$("#deletepopup").modal("hide");
            this.deletemulitiiadosdocs(DownDelete, this.state.ProjectId, this.state.UserRole)
            this.state.DownDelete = [];
            this.setState({});
            $('input[type=checkbox]').prop('checked', false);
        }
        else {
            this.deleteInitial(this.state.EditAudit, this.state.UserRole)

        }

    }
    deletemulitiiadosdocs = (data, id, modify) => {
        let ids = "";
        if (data && data.length > 0) {
            data.map((val, index) => {
                if (index == 0) {
                    ids += "ids=" + val;
                }
                else {
                    ids += "&ids=" + val;
                }
            })
        }
        let apiUrl = API.IADOS_LISTVIEW + '/ids?' + ids + '&modify=' + modify
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.hide = 0;
                    this.state.searchData = {
                        ProjectId: 0,
                        FromDate: '',
                        ToDate: '',
                        PageNumber: 1,
                        PageSize: 10,
                        SortBy: 'date',
                        SortOrder: 'asc'
                    };
                    this.setState({})
                    this.dataTable(this.state.searchData, this.state.ProjectId)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            })
    };
    deleteInitial = (id, modify) => {
        let apiUrl = API.INITIAL_AUDIT + '/' + id + '?modify=' + modify
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.EditAudit = 0;
                    this.setState({})
                    this.AuditTable(this.state.ProjectId)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    handleCheckboxChange = (e, x) => {
        const { DownDelete } = this.state;
        if (DownDelete.length == 0) {
            DownDelete.push(x)
        }
        else {
            if (DownDelete.filter((i) => i == x).length == 1) {
                DownDelete.map((i, ind) => (
                    i == x ?
                        DownDelete.splice(ind, 1)
                        : ""
                ))
            } else {
                DownDelete.push(x)
            }
        }
        this.setState({})
        if (DownDelete.length == 1) {
            localStorage.setItem("IADOSEditId", DownDelete[0])
            localStorage.setItem("IADOSViewId", DownDelete[0])
        }
        this.state.hide = DownDelete.length;
        this.setState({})
    };
    handleCheckboxChange1 = (e, x) => {
        let data = x;
        if (this.state.EditAudit == 0) {
            this.state.EditAudit = data
            this.setState({})
            localStorage.setItem("AuditEditId", x)
        }
        else {
            this.state.EditAudit = 0
            this.setState({})
        }
    };
    ResetFilter() {
        const { dispatch } = this.props;
        const input = {
            FromDate: '',
            ToDate: '',
            PageNumber: 1,
            PageSize: 10,
            SortBy: 'date',
            SortOrder: 'asc'
        };
        this.state.searchData = input;
        this.setState({});
    }
    handleDateChange = (e, node) => {
        this.state.searchData[node] = e.target.value;
        this.setState({});
    };
    dataTable = (data, id) => {
        let apiUrl = API.IADOS_LISTVIEW + "?projectId=" + id + "&FromDate=" + data.FromDate + "&ToDate=" + data.ToDate + '&SortBy=' + data.SortBy + '&SortOrder=' + data.SortOrder +'&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        //  this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    destroyDataTable("staffTable");
                    this.props.dispatch({ type: "IADOS_LIST_DOCS", data: response.data });
                    applyDataTable("staffTable", "", [{ "orderable": false, "targets": [0], visible: this.state.isAccess === false ? false : true }, { type: 'day', targets: [1] }], "", "", "", this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY",[this.state.index,data.SortOrder]);
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    AuditTable = (id) => {
        let apiUrl = API.INITIAL_AUDIT + "/projectId?projectId=" + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        destroyDataTable("staffTable1")
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.dispatch({ type: "IADOSAUDIT_DOCS", data: response.data });
                    // applyDataTable("staffTable1", "", [{ "orderable": false, "targets": [0] },{ type: 'day', targets: [1] }], "", "", "", this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                this.props.dispatch({ type: "IADOSAUDIT_DOCS", data: [] });
                this.setState({
                    Audit_ListView: [],
                })
                if (error?.response?.status === 401) {

                }
            });
    }
    Search = () => {
        const { dispatch } = this.props;
        this.state.index=1;
        this.state.searchData.SortBy='date'
        this.state.searchData.SortOrder='asc'
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId)
    }

    handleSort = (data,ind) => {
        if (this.state.searchData.SortBy === data) {
            this.state.searchData.SortOrder = this.state.searchData.SortOrder === "asc" ? "desc" : "asc";
        }
        else {
            this.state.searchData.SortOrder = "asc";
        }
        this.state.searchData.SortBy = data
        this.state.searchData.PageNumber = 1;
        this.setState({
            index:ind
        });
        this.dataTable(this.state.searchData, this.state.ProjectId);

    }
    render() {

        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"INIT" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="INIT" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Initial Audit & Daily Observation Status </h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }

                <div className={`${this.state.isMobile ? this.state.isAccess ? this.state.value == 1 ? "border-top" : "border-top" : this.state.value == 1 ? "" : "border-top" : ""} ml-auto scroll-hide`} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ?
                        this.state.isAccess ? <>
                            <div className="row border-bottom">
                                <div className="input-group">
                                    {this.state.value == 0 ?
                                        <div className="col-3 col-sm-3 border-right text-center pt-3" style={{ whiteSpace: 'nowrap' }}>
                                            <span className={`${this.state.hide == 1 ? "span-enabled" : "span-disabled"}`} onClick={this.ViewPage}><img src={View} style={{ marginTop: '-4px', opacity: this.state.hide == 1 ? '' : '0.5' }}></img>&nbsp;View</span>
                                        </div>
                                        : <></>}

                                    <div className={this.state.value == 1 ? "col-4 col-sm-4 border-right text-center pt-3" : " col-3 col-sm-3 border-right text-center pt-3"} style={{ whiteSpace: 'nowrap' }}>
                                        <span className={`${this.state.isAccess ? this.state.value == 1 ? this.state.EditAudit != 0 ? "span-enabled" : "span-disabled" : this.state.hide == 1 ? "span-enabled" : "span-disabled" : "span-disabled"}`} disabled={this.state.value == 1 ? this.state.EditAudit != 0 ? false : true : this.state.hide == 1 ? false : true} onClick={this.EditPage}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.isAccess ? this.state.value == 1 ? this.state.EditAudit != 0 ? "" : "0.5" : this.state.hide == 1 ? '' : '0.5' : '0.5' }}></img>&nbsp;Edit</span>
                                    </div>
                                    <div className={this.state.value == 1 ? "col-4 col-sm-4 border-right text-center pt-3 pl-2" : "col-3 col-sm-3 border-right text-center pt-3 pl-2"} style={{ whiteSpace: 'nowrap' }}>
                                        <span className={`${this.state.isAccess ? this.state.value == 1 ? this.state.EditAudit != 0 ? "span-enabled" : "span-disabled" : this.state.hide > 0 ? "span-enabled" : "span-disabled" : "span-disabled"}`} data-target="#deletepopup" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.isAccess ? this.state.value == 1 ? this.state.EditAudit != 0 ? "" : "0.5" : this.state.hide > 0 ? '' : '0.5' : '0.5' }}></img>&nbsp;Delete</span>
                                    </div>
                                    <div className={this.state.value == 1 ? "col-4 col-sm-4 pt-3  text-center pb-3 pl-1" : "col-3 col-sm-3 pt-3  text-center pb-3 pl-1"} style={{ whiteSpace: 'nowrap' }}>
                                        <span className={`${this.state.isAccess ? this.state.value == 1 ? this.state.Audit_ListView == "" ? "span-enabled" : "span-disabled" : "span-enabled" : "span-disabled"}`} onClick={this.AddNew}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isAccess ? this.state.value == 1 ? this.state.Audit_ListView == "" ? '' : '0.5' : "" : '0.5' }}></i>Add New</span>
                                    </div>

                                </div>
                            </div>
                        </> : <></>
                        :
                        <>
                            {this.state.isAccess ? <>
                                <div className={this.state.isAccess ? "row  border-bottom" : this.state.value === 1 ? "row" : "row  border-bottom"}>
                                    <div className="col-xl-3  col-md-3 col-lg-3 col-sm-3 d-flex">
                                        {this.state.value == 0 ?
                                            <button className={`${classes.button} ${this.state.isAccess ? "" : "p-3"} pl-3`} disabled={this.state.hide == 1 ? false : true} onClick={this.ViewPage} style={{ minWidth: '70px' }}><img src={View} style={{ marginTop: '-4px', opacity: this.state.hide == 1 ? '' : '0.5' }}></img>&nbsp;View</button>
                                            : <></>}

                                        <button className={`${classes.button} ${this.state.value === 1 ? "pl-3" : ""} `} disabled={this.state.isAccess ? this.state.value == 1 ? this.state.EditAudit != 0 ? false : true : this.state.hide == 1 ? false : true : true} onClick={this.EditPage} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.isAccess ? this.state.value == 1 ? this.state.EditAudit != 0 ? "" : "0.5" : this.state.hide == 1 ? '' : '0.5' : '0.5' }}></img>&nbsp;Edit</button>
                                        <button className={`${classes.button}`} disabled={this.state.isAccess ? this.state.value == 1 ? this.state.EditAudit != 0 ? false : true : this.state.hide > 0 ? false : true : true} data-target="#deletepopup" data-toggle="modal" style={{ minWidth: '70px', opacity: this.state.isAccess ? this.state.value == 1 ? this.state.EditAudit != 0 ? "" : "0.5" : this.state.hide > 0 ? '' : '0.5' : '0.5' }}><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>

                                        <div className="col-xl-12 p-3 col-md-12 col-lg-12 col-sm-12  ml-2 border-left">
                                            <button className={classes.button} disabled={this.state.isAccess ? this.state.value == 1 ? this.state.Audit_ListView == "" ? false : true : false : true} onClick={this.AddNew} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isAccess ? this.state.value == 1 ? this.state.Audit_ListView == "" ? '' : '0.5' : "" : '0.5' }}></i>Add New</button>
                                        </div>

                                    </div>
                                </div>
                            </> : <></>}
                        </>
                    }
                    <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                        <div className="col-12 mt-3 px-3">
                            {this.state.isMobile ? <></> : <h6>Initial Audit & Daily Observation Status</h6>}
                        </div>
                        <div className="row " >
                            <div>
                                <AppBar position="static" color="inherit" className={classes.root}>
                                    <Tabs
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                        classes={{ indicator: classes.indicator }}
                                    >
                                        <Tab label="Daily Observation Status" className="px-1 ml-4" style={{ textTransform: "none", minWidth: '13px' }}{...a11yProps(0)} />
                                        <Tab label="Initial Audit" style={{ textTransform: "none", minWidth: '13px' }}{...a11yProps(1)} />
                                    </Tabs>
                                </AppBar>
                                <TabPanel value={this.state.value} index={0}>
                                    <div className={this.state.isMobile ? "row px-0 mt-n4" : "row px-2 mt-n4"}>
                                        <div className="row px-3">
                                            <div className="col-12 pt-1">
                                                <button data-toggle="modal" data-target="#custom-modal" className={`${classes.button} float-end`} style={{ minWidth: '70px' }}><img src={FilterIcon} />&nbsp;Filter </button>
                                            </div>
                                        </div>
                                        <div className={this.state.isMobile ? "col-12 px-2 pt-2 mt-1" : "col-sm-12 col-12 px-0 pt-2 mt-1"}>
                                            <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                                <table id="staffTable" className="dataTable">
                                                    <thead>
                                                        <tr className="">
                                                            <th width="3%" className="align-middle border-top border-left"><span className="spandoc-thead" style={{ color: "#000000" }}></span></th>
                                                            <th width="8%" className="border-right  align-middle border-left border-top" style={{ minWidth: '70px' }} onClick={() => this.handleSort('date',1)}><span className="spandoc-thead" style={{ color: "#000000" }}>Date</span></th>
                                                            <th width="10%" style={{ minWidth: window.innerWidth < 1000 ? '100px' : "70px" }} className="border-right align-middle border-top" onClick={() => this.handleSort('location',2)}><span className="spandoc-thead" style={{ color: "#000000" }}>Location</span></th>
                                                            <th width="8%" style={{ minWidth: window.innerWidth < 1000 ? '100px' : "70px" }} className="border-right align-middle border-top" onClick={() => this.handleSort('category',3)}><span className="spandoc-thead" style={{ color: "#000000" }}>Category</span></th>
                                                            <th width="8%" style={{ minWidth: window.innerWidth < 1000 ? '100px' : "70px" }} className="border-right align-middle border-top" onClick={() => this.handleSort('status',4)}><span className="spandoc-thead" style={{ color: "#000000" }}>Status</span></th>
                                                            <th width="" style={{ minWidth: window.innerWidth < 1000 ? '400px' : "" }} className="border-right align-middle border-top" onClick={() => this.handleSort('observation',5)}><span className="spandoc-thead" style={{ color: "#000000" }}>Observation</span></th>
                                                            <th width="" style={{ minWidth: window.innerWidth < 1000 ? '400px' : "" }} className="border-right align-middle border-top" onClick={() => this.handleSort('correctiveaction',6)}><span className="spandoc-thead" style={{ color: "#000000" }}>Corrective Action</span></th>
                                                            <th width="" style={{ minWidth: window.innerWidth < 1000 ? '400px' : "" }} className="border-right align-middle border-top" onClick={() => this.handleSort('responsible',7)}><span className="spandoc-thead" style={{ color: "#000000" }}>Responsible Department</span></th>
                                                            <th width="10%" style={{ minWidth: window.innerWidth < 1000 ? '100px' : "70px" }} className="border-right align-middle border-top" onClick={() => this.handleSort('targetdate',8)}><span className="spandoc-thead" style={{ color: "#000000" }}>Target Date</span></th>
                                                            <th width="12%" style={{ minWidth: window.innerWidth < 1000 ? '100px' : "70px" }} className="border-top align-middle border-right" onClick={() => this.handleSort('completiondate',9)}><span className="spandoc-thead" style={{ color: "#000000" }}>Completion Date</span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.props.IADOS_ListView?.Observations && this.props.IADOS_ListView?.Observations.map((i, v) => (
                                                            <>
                                                                <tr>
                                                                    <td className="spandoc-td align-middle border-left"><input type="checkbox" checked={this.state.DownDelete.filter(r=> r === i.Id).length == 1 ? true : false} style={{ width: "16px", height: "16px" }} onChange={(e) => this.handleCheckboxChange(e, i.Id)} /></td>
                                                                    <td className="spandoc-td border-right border-left font align-middle">
                                                                        {i.Date && moment(i.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                    </td>
                                                                    <td className="spandoc-td border-right font align-middle"><a href="" onClick={() => this.ViewPageLink(i.Id)}>{i.Location}</a></td>
                                                                    <td className="spandoc-td border-right font align-middle">{i.Category}</td>
                                                                    <td className="spandoc-td border-right font align-middle">{i.Status}</td>
                                                                    <td className="spandoc-td border-right font align-middle">{i.Observation}</td>
                                                                    <td className="spandoc-td border-right font align-middle">{i.CorrectiveAction}</td>
                                                                    <td className="spandoc-td border-right font align-middle">{i.ResponsibleDepartment}</td>
                                                                    <td className="spandoc-td border-right font align-middle">
                                                                        {i.TargetDate && moment(i.TargetDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                    </td>
                                                                    <td className="spandoc-td border-right font align-middle">
                                                                        {i.CompletionDate && moment(i.CompletionDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel value={this.state.value} index={1}>
                                    <div className={this.state.isMobile ? "row px-0 mt-n4" : "row px-2 mt-n4"}>
                                        <div className={this.state.isMobile ? "col-12 px-2 pt-2 mt-1" : "col-sm-12 col-12 px-0 pt-2 mt-1"}>
                                            <div className="table-responsive pb-3" style={{ width: "100%" }}>
                                                <table id="staffTable1" className="dataTable">
                                                    <thead>
                                                        <tr className="">
                                                            {this.state.isAccess ? 
                                                            <th width="3%" className="border-top border-left"><span className="spandoc-thead" style={{ color: "#000000" }}></span></th>
                                                            :""}
                                                            <th width="10%" className="border-right  border-left border-top "><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Total Findings</span></th>
                                                            <th width="10%" className="border-right border-top "><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Minor</span></th>
                                                            <th width="10%" className="border-right border-top "><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Major</span></th>
                                                            <th width="13%" className="border-right border-top "><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>No.Of Findings Closed</span></th>
                                                            <th width="10%" className="border-right border-top "><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Minor</span></th>
                                                            <th width="10%" className="border-right border-top "><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Major</span></th>
                                                            <th width="12%" className="border-right border-top "><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>No.Of Findings Open</span></th>
                                                            <th width="10%" className="border-right border-top "><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Minor</span></th>
                                                            <th width="10%" className="border-top border-right "><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Major</span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <>
                                                            {this.props.Audit_ListView.length == 0 ? <></> : <>
                                                                <tr>
                                                                    <>
                                                                    {this.state.isAccess ? 
                                                                        <td className="spandoc-td align-middle border-left"><input type="checkbox" style={{ width: "16px", height: "16px" }} onChange={(e) => this.handleCheckboxChange1(e, this.props.Audit_ListView.Id)} /></td>
                                                                        :""}
                                                                        <td className="spandoc-td border-right border-left align-middle font text-right">{this.props.Audit_ListView.TotalFindings && this.props.Audit_ListView.TotalFindings}</td>
                                                                        <td className="spandoc-td border-right align-middle font text-right">{this.props.Audit_ListView.TotalMinor && this.props.Audit_ListView.TotalMinor}</td>
                                                                        <td className="spandoc-td border-right align-middle font text-right">{this.props.Audit_ListView.TotalMajor && this.props.Audit_ListView.TotalMajor}</td>
                                                                        <td className="spandoc-td border-right align-middle font text-right">{this.props.Audit_ListView.NoofFindingsClose && this.props.Audit_ListView.NoofFindingsClose}</td>
                                                                        <td className="spandoc-td border-right align-middle font text-right">{this.props.Audit_ListView.MinorClose && this.props.Audit_ListView.MinorClose}</td>
                                                                        <td className="spandoc-td border-right align-middle font text-right">{this.props.Audit_ListView.MajorClose && this.props.Audit_ListView.MajorClose}</td>
                                                                        <td className="spandoc-td border-right align-middle font text-right">{this.props.Audit_ListView.NoofFindingsOpen && this.props.Audit_ListView.NoofFindingsOpen}</td>
                                                                        <td className="spandoc-td border-right align-middle font text-right">{this.props.Audit_ListView.MinorOpen && this.props.Audit_ListView.MinorOpen}</td>
                                                                        <td className="spandoc-td border-right align-middle font text-right">{this.props.Audit_ListView.MajorOpen && this.props.Audit_ListView.MajorOpen}</td>
                                                                    </>
                                                                </tr>
                                                            </>}
                                                        </>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className={this.state.isMobile ? "fw-bold mt-1 px-2" : "fw-bold mt-1 px-0"}>
                                            Note: For more details, kindly refer "Audit & Corrective Action" report in the Yard documents.
                                        </div>
                                    </div>
                                </TabPanel>
                            </div>
                        </div>

                    </div>
                    <div className="modal left fade pt-5 mt-3" id="custom-modal" tabIndex={-1} role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" style={{ width: this.state.isMobile ? "250px" : "" }}>
                            <div className="modal-content border-radius">
                                <div className="modal-header">
                                    <div className="row m-0">
                                        <h6 className="modal-title" id="myCenterModalLabel">Advanced Filter</h6>
                                        <div className="col-12">
                                            <span className="cursorPointer" onClick={() => this.ResetFilter()}>
                                                <img src={FilterIcon} />&nbsp;<span>Reset to default</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body p-4">
                                    <form id="myform">
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Date - From</label></div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    value={this.state.searchData.FromDate && moment(this.state.searchData.FromDate).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.FromDate && moment(this.state.searchData.FromDate).format("DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleDateChange(e, "FromDate") }}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Date - To</label></div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    value={this.state.searchData.ToDate && moment(this.state.searchData.ToDate).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.ToDate && moment(this.state.searchData.ToDate).format("DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleDateChange(e, "ToDate") }}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                />
                                            </div>
                                        </div>
                                        <div className="row text-center mt-4">
                                            {this.state.isMobile ? <></> : <div className="col-2"></div>}
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" className={`btn btn-primary input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`} data-toggle="modal" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }} onClick={() => this.Search()}>Search</button>
                                            </div>
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" id="closemodal" className={`btn btn-light input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`}>Cancel</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div >
                    <div class="modal fade  p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button id="closemodal1" type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.value == 0 ? <>
                    <div className={`${classes.pagination}`}>
                        <div className={`${classes.paginationItem}`}>
                            {this.state.searchData.PageNumber == 1 ? <></> :
                                <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                            <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                            {(this.state.searchData.PageNumber == this.props.IADOS_ListView?.pagination?.PageCount) || (this.props.OPA_ListView?.pagination?.PageCount == 0) ? <></> :
                                <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                        </div>
                    </div></> : <></>}

            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        IADOS_ListView: state.IADOSReducer.IADOS_ListView || [],
        Audit_ListView: state.IADOSReducer.Audit_ListView || [],
        settings: state.commonReducer.settings || [],
    };
}

ListViewIADOS.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewIADOS))
);

